
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["cleanDB","updateLastUtime"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "0435993f6326a21839c1.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			